module.exports = __webpack_public_path__ + "static/img/Default.a62ad72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Default.jpg
// module id = CY7C
// module chunks = 1